import { useQuery, useQueryClient } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { PurchaseOrderPaginationOptions } from "src/types";

interface UsePurchaseOrdersForRelabelCaseBuilderOptions {
  enabled?: boolean;
}

const usePurchaseOrdersForRelabelCaseBuilder = (
  purchaseOrderService: PurchaseOrderService,
  paginationOptions: PurchaseOrderPaginationOptions = {},
  options: UsePurchaseOrdersForRelabelCaseBuilderOptions = {}
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getPurchaseOrdersForRelabelCaseBuilderQueryParams(paginationOptions);

  const {
    data: paginatedPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedPurchaseOrdersForRelabelCaseBuilder(queryParams),
    queryFn: () => purchaseOrderService.getPurchaseOrdersForRelabelCaseBuilder(queryParams),
    enabled: options.enabled ?? true
  });

  const refreshPurchaseOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedPurchaseOrdersForRelabelCaseBuilder(),
      exact: false
    });
  };

  return { paginatedPurchaseOrders, fetchError, isLoading, refreshPurchaseOrders };
};

export { usePurchaseOrdersForRelabelCaseBuilder };
